import React from 'react';
import { Col, Row, Card } from 'antd';
import { token, lang, baseURL } from '../../api/config';
import '../../assets/iconfont.css';
import styles from './index.module.less';

export default function ChangeLog({ changelogs = [] }) {
  return (
    <div className='singular-row'>
      <Row gutter={[20, 20]}>
        {
          // 遍历组中的每个文件
          changelogs.map((name, index) => (
            <Col
              key={index}
              span={6}
            >
              <Card>
                <div className='card-content'>
                  <div className='card-content-left'>
                    <div className={styles.file_title}>
                      {`${name}_CHANGELOG`}
                    </div>
                  </div>
                  <div className='download'>
                    <i
                      className='iconfont icon-download'
                      onClick={() => {
                        fetch(
                          `${baseURL}/api/plm/product/series/${name}/release-notes.md?access_token=${token}&mode=inline&firmware_category=firmware&lang=${lang}`
                        )
                          .then(response => response.blob())
                          .then(blob => {
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `${name}_CHANGELOG.md`;
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                          })
                          .catch(error => {
                            console.error('Error downloading file:', error);
                          });
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Col>
          ))
        }
      </Row>
    </div>
  );
}
